import React from "react";
import { VariantProps } from "class-variance-authority";
import { FieldError, RegisterOptions, useFormContext } from "react-hook-form";

import Input, { sizeVariants } from "@/components/atoms/input/Input";
import FormControl, { FormControlProps } from "@/components/molecules/form/FormControl";

type FormInputProps = {
  name: string;
  leftPlaceholder?: React.ReactNode | string;
  tooltip?: React.ReactNode | string;
  rules?: RegisterOptions;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  type?: string;
} & VariantProps<typeof sizeVariants> &
  Omit<FormControlProps, "id" | "children">;

const FormInput = ({
  name,
  leftPlaceholder,
  tooltip,
  rules,
  disabled = false,
  placeholder,
  className,
  type = "text",
  sizing,
  ...rest
}: FormInputProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name] as FieldError | undefined;

  return (
    <FormControl id={name} error={error?.message} {...rest}>
      <Input
        id={name}
        {...register(name, rules)}
        type={type}
        leftPlaceholder={leftPlaceholder}
        tooltip={tooltip}
        sizing={sizing}
        className={className}
        hasError={!!error}
        disabled={disabled}
        placeholder={placeholder}
      />
    </FormControl>
  );
};

export default FormInput;
